//* Default type exports for partial booking analytics
export * from './learning-methods';
export class BookingAnalytics {
    totalBookings;
    constructor(totalBookings) {
        this.totalBookings = totalBookings;
    }
    data;
}
export class BookingAnalyticsData {
    learningMethods;
}
